// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import bootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import router from './router'
import axios from 'axios'
import vueCookies from 'vue-cookies'
import store from './store/store.js'
import apiHandler from './utils/ApiHandler.js'
import '@/assets/js/application.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueClipboard from 'vue-clipboard2'
import 'swiper/dist/css/swiper.css'
import '@/assets/css/_globals.scss'

Vue.config.productionTip = false

Vue.prototype.$http = axios
Vue.prototype.$eventHub = new Vue()

Vue.use(vueCookies)
Vue.use(apiHandler)
Vue.use(bootstrapVue)
Vue.use(require('vue-moment'))
Vue.use(VueAwesomeSwiper)
Vue.use(VueClipboard)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted () {
  }
})



// WEBPACK FOOTER //
// ./src/main.js